import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke302aRequest, Sgke302aResponse, Sgke302aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke302aService {
  /**
   * コンストラクタ
   * @param service Sgke302aService
   * @param apiCommonService ApiCommonService
   * @param featuresLibConfig 
   */
  constructor(private service: Sgke302aService, public apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) {

  }

  public doSgke302a(sgke302aRequest: Sgke302aRequest, noCheckError = false): Observable<Sgke302aResponse> {
    //日付のフォーマットをYYMMDDに変更
    this.apiCommonService.convertElementInObject(sgke302aRequest, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    return this.service.sgke302aPost(this.apiCommonService.setRequestCommon(sgke302aRequest), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }
        ),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE302A');
          return throwError(err.message);
        })
      );
  }

}
